module.exports = __webpack_public_path__ + "assets/img/banner2025.fd459fc.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/banner2025.png
// module id = 581
// module chunks = 1